import { InjectionToken } from '@angular/core';

export class ContractHistoryConfiguration {
  apiRoot: string | null = null;
}

export const CONTRACT_HISTORY_CONFIGURATION = new InjectionToken<ContractHistoryConfiguration>(
  'ContractHistoryConfiguration'
);
